module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header pinned"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('header-bar-left')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('header-bar-right')], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "main pinned"
  }, [_c('el-col', {
    staticClass: "full-height left-container",
    attrs: {
      "span": 4
    }
  }, [_c('nav-menu'), _vm._v(" "), _c('os-usage')], 1), _vm._v(" "), _c('el-col', {
    staticClass: "full-height",
    attrs: {
      "span": 20
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-589319ee"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 167
// module chunks = 1